export const mappingImageDefault = (image: string): string => {
  const keyword = /item_B62CB79F-1CE7-4D80-86EA-F844804803BE.png/

  if(image.match(keyword)){
    return '/icons/coupon-image-placeholder.svg'
  }
  return image
}